import {Component, Input, Output,EventEmitter} from '@angular/core';
import { DateAdapter } from '@angular/material';

/** @title Basic datepicker */
@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.html',
  styleUrls: ['datepicker.css'],
})
export class Datepicker {
  constructor(private dateAdapter:DateAdapter<Date>){
    this.dateAdapter.setLocale('en-GB');
    this.dateChange =new EventEmitter();
  }

  data:Date=new Date();
  @Output() public dateChange : EventEmitter<string>;
  get dataProperty():Date{
    return this.data;
  }
  @Input()
  set dataProperty(data:Date) { 
    console.log("il set della data è stato chiamato, valore: "+data);
    let newData=new Date(data);
    this.dateChange.emit(newData.toString());
    this.data=newData;
  
  }

}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */


// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/datepicker.ts